import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home.jsx";
import CeramicMississauga from "./pages/CeramicMississauga.jsx";
import CeramicToronto from "./pages/CeramicToronto.jsx";
import CeramicVaughan from "./pages/CeramicVaughan.jsx";
import PaintCorrectionPage from "./pages/PaintCorrectionPage.jsx";
import AutoDetailingPage from "./pages/AutoDetailingPage.jsx";
import MediaPage from "./pages/MediaPage.jsx";
import ReviewsPage from "./pages/ReviewsPage.jsx";
import Blog from "./pages/Blog.jsx";
import BlogPost from "./pages/BlogPost.jsx";
import Offer from "./pages/Offer.jsx";
import Analytics from "./components/Analytics.jsx";
import StickyQuoteBadge from "./components/StickyQuoteBadge.jsx";
import ScrollToHash from "./components/ScrollToHash.jsx";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <Analytics />
      <div className="App bg-jester-deep text-white min-h-screen">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ceramic-coating-mississauga" element={<CeramicMississauga />} />
            <Route path="/ceramic-coating-toronto" element={<CeramicToronto />} />
            <Route path="/ceramic-coating-vaughan" element={<CeramicVaughan />} />
            <Route path="/paint-correction-mississauga" element={<PaintCorrectionPage />} />
            <Route path="/auto-detailing-mississauga" element={<AutoDetailingPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/offer" element={<Offer />} />
          </Routes>
        </BrowserRouter>
        <StickyQuoteBadge />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
